import React, { Component } from 'react';
import FourZeroFour from '../fourzerofour';
import PDHeader from './PDHeader';
import PDDetail from './PDDetail';
import Footer from '../footer';

class CanonEquipmentRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = { product_details: null };
        this.getProductDetail();
    }

    getProductDetail() {
        let Id = this.props.match.params.productId;
        window.fetch(`http://www.signsandimpressions.com/db?productId=${Id}&productArea=CanonEquipment`)
            .then(response => response.json())
            .then(data => this.setState({ product_details: data })).
            catch(() => { this.setState({ product_details: "failed" }) });
    }

    render() {
        const data = this.state.product_details;
        if (data && data !== "failed") {
            return (
                <>
                    <div id="productDetails" className="container">
                        <PDHeader item={data} />
                        <PDDetail rendercolor={data.RenderColor1} detailcolumns={data.DetailColumns} Videos={data.Videos} />
                    </div>
                    <Footer />
                </>
            )
        }
        if (data === "failed")
            return (
                <FourZeroFour />
            )

        return null;
    }
}

export default CanonEquipmentRenderer;